import styled from 'styled-components'

export const StyledBlog = styled.div`
  .article-page {
    margin-top: 32px;
    .content {
      width: 860px;
      margin: 0 auto;
      padding-bottom: 100px;
      h2 {
        font-size: 27px;
        line-height: 31px;
        color: #1b2e36;
      }

      .updated-at {
        font-size: 15px;
        line-height: 22px;
        color: #8992b1;
        margin-top: 13px;
      }

      .article-body {
        margin-top: 35px;
        border-top: 1px solid #eaecf6;
        padding-top: 35px;

        p {
          line-height: 1.5;
          color: #43454f;
          margin: 1em 0;
          word-break: break-all;
          span {
            font-size: 15px;
            line-height: 25px;
            color: #43454f;
          }
        }

        em {
          span {
            word-break: break-all;
          }
        }

        h2 {
          font-size: 17px;
          line-height: 22px;
          color: #43454f;
          margin-top: 30px;
          margin-bottom: 15px;
        }

        h3 {
          font-size: 15px;
          line-height: 25px;
          color: #43454f;
          margin: 1em 0;
        }

        img {
          max-width: 100%;
        }

        .wysiwyg-text-align-center {
          text-align: center;
        }
      }
    }
  }

  @media (max-width: 860px) {
    .article-page {
      .content {
        width: 100%;
        padding: 0 20px 100px 20px;

        img {
          max-width: 80vw;
          height: unset;
        }

        span {
          word-break: break-all;
        }

        .article-body {
          iframe {
            max-width: 100%;
            height: unset;
          }
          em {
            span {
              word-break: break-all;
            }
          }
        }
      }
    }
  }
`
